import React, { Component } from "react";
import { connect } from "react-redux";
// @ts-expect-error
import VideoLayout from "../../../../modules/UI/videolayout/VideoLayout";
import { isDisplayNameVisible } from "../../base/config/functions.web";
import { VIDEO_TYPE } from "../../base/media/constants";
import { getLocalParticipant } from "../../base/participants/functions";
import Watermarks from "../../base/react/components/web/Watermarks";
import { getHideSelfView } from "../../base/settings/functions.any";
import { getVideoTrackByParticipant } from "../../base/tracks/functions.web";
import { setColorAlpha } from "../../base/util/helpers";
import { isSpotTV } from "../../base/util/spot";
import StageParticipantNameLabel from "../../display-name/components/web/StageParticipantNameLabel";
import { FILMSTRIP_BREAKPOINT } from "../../filmstrip/constants";
import { getVerticalViewMaxWidth, isFilmstripResizable } from "../../filmstrip/functions.web";
import SharedVideo from "../../shared-video/components/web/SharedVideo";
import Captions from "../../subtitles/components/web/Captions";
import { areClosedCaptionsEnabled } from "../../subtitles/functions.any";
import { setTileView } from "../../video-layout/actions.web";
import Whiteboard from "../../whiteboard/components/web/Whiteboard";
import { isWhiteboardEnabled } from "../../whiteboard/functions";
import { setSeeWhatIsBeingShared } from "../actions.web";
import { getLargeVideoParticipant } from "../functions";
import ScreenSharePlaceholder from "./ScreenSharePlaceholder.web";
/** .
 * Implements a React {@link Component} which represents the large video (a.k.a.
 * The conference participant who is on the local stage) on Web/React.
 *
 * @augments Component
 */
class LargeVideo extends Component {
    _tappedTimeout;
    _containerRef;
    _wrapperRef;
    /**
     * Constructor of the component.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._containerRef = React.createRef();
        this._wrapperRef = React.createRef();
        this._clearTapTimeout = this._clearTapTimeout.bind(this);
        this._onDoubleTap = this._onDoubleTap.bind(this);
        this._updateLayout = this._updateLayout.bind(this);
    }
    /**
     * Implements {@code Component#componentDidUpdate}.
     *
     * @inheritdoc
     */
    componentDidUpdate(prevProps) {
        const { _visibleFilmstrip, _isScreenSharing, _seeWhatIsBeingShared, _largeVideoParticipantId, _hideSelfView, _localParticipantId, } = this.props;
        if (prevProps._visibleFilmstrip !== _visibleFilmstrip) {
            this._updateLayout();
        }
        if (prevProps._isScreenSharing !== _isScreenSharing && !_isScreenSharing) {
            this.props.dispatch(setSeeWhatIsBeingShared(false));
        }
        if (_isScreenSharing && _seeWhatIsBeingShared) {
            VideoLayout.updateLargeVideo(_largeVideoParticipantId, true, true);
        }
        if (_largeVideoParticipantId === _localParticipantId && prevProps._hideSelfView !== _hideSelfView) {
            VideoLayout.updateLargeVideo(_largeVideoParticipantId, true, false);
        }
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {React$Element}
     */
    render() {
        const { _displayScreenSharingPlaceholder, _isChatOpen, _isDisplayNameVisible, _noAutoPlayVideo, _showDominantSpeakerBadge, _whiteboardEnabled, _showSubtitles, } = this.props;
        const style = this._getCustomStyles();
        const className = "videocontainer";
        return (React.createElement("div", { className: className, id: "largeVideoContainer", ref: this._containerRef, style: style },
            React.createElement(SharedVideo, null),
            _whiteboardEnabled && React.createElement(Whiteboard, null),
            React.createElement("div", { id: "etherpad" }),
            React.createElement(Watermarks, null),
            React.createElement("div", { id: "dominantSpeaker", onTouchEnd: this._onDoubleTap },
                React.createElement("div", { className: "dynamic-shadow" }),
                React.createElement("div", { id: "dominantSpeakerAvatarContainer" })),
            React.createElement("div", { id: "remotePresenceMessage" }),
            React.createElement("span", { id: "remoteConnectionMessage" }),
            React.createElement("div", { id: "largeVideoBackgroundContainer" }),
            React.createElement("div", { id: "largeVideoElementsContainer" },
                _displayScreenSharingPlaceholder ? React.createElement(ScreenSharePlaceholder, null) : React.createElement(React.Fragment, null),
                React.createElement("div", { id: "largeVideoWrapper", onTouchEnd: this._onDoubleTap, ref: this._wrapperRef, role: "figure" },
                    React.createElement("video", { autoPlay: !_noAutoPlayVideo, id: "largeVideo", muted: true, playsInline: true }))),
            !interfaceConfig.DISABLE_TRANSCRIPTION_SUBTITLES && _showSubtitles && React.createElement(Captions, null),
            _isDisplayNameVisible && _showDominantSpeakerBadge && React.createElement(StageParticipantNameLabel, null)));
    }
    /**
     * Refreshes the video layout to determine the dimensions of the stage view.
     * If the filmstrip is toggled it adds CSS transition classes and removes them
     * when the transition is done.
     *
     * @returns {void}
     */
    _updateLayout() {
        const { _verticalFilmstripWidth, _resizableFilmstrip } = this.props;
        if (_resizableFilmstrip && Number(_verticalFilmstripWidth) >= FILMSTRIP_BREAKPOINT) {
            this._containerRef.current?.classList.add("transition");
            this._wrapperRef.current?.classList.add("transition");
            VideoLayout.refreshLayout();
            setTimeout(() => {
                this._containerRef?.current?.classList.remove("transition");
                this._wrapperRef?.current?.classList.remove("transition");
            }, 1000);
        }
        else {
            VideoLayout.refreshLayout();
        }
    }
    /**
     * Clears the '_tappedTimout'.
     *
     * @private
     * @returns {void}
     */
    _clearTapTimeout() {
        clearTimeout(this._tappedTimeout);
        this._tappedTimeout = undefined;
    }
    /**
     * Creates the custom styles object.
     *
     * @private
     * @returns {Object}
     */
    _getCustomStyles() {
        const styles = {};
        const { _customBackgroundColor, _customBackgroundImageUrl, _verticalFilmstripWidth, _verticalViewMaxWidth, _visibleFilmstrip, } = this.props;
        styles.background = _customBackgroundColor || interfaceConfig.DEFAULT_BACKGROUND;
        if (this.props._backgroundAlpha !== undefined) {
            const alphaColor = setColorAlpha(styles.backgroundColor, this.props._backgroundAlpha);
            styles.background = alphaColor;
        }
        if (_customBackgroundImageUrl) {
            styles.backgroundImage = `url(${_customBackgroundImageUrl})`;
            styles.backgroundSize = "cover";
        }
        if (_visibleFilmstrip && Number(_verticalFilmstripWidth) >= FILMSTRIP_BREAKPOINT) {
            styles.width = `calc(100% - ${_verticalViewMaxWidth || 0}px)`;
        }
        return styles;
    }
    /**
     * Sets view to tile view on double tap.
     *
     * @param {Object} e - The event.
     * @private
     * @returns {void}
     */
    _onDoubleTap(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this._tappedTimeout) {
            this._clearTapTimeout();
            this.props.dispatch(setTileView(true));
        }
        else {
            this._tappedTimeout = window.setTimeout(this._clearTapTimeout, 300);
        }
    }
}
/**
 * Maps (parts of) the Redux state to the associated LargeVideo props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const testingConfig = state["features/base/config"].testing;
    const { backgroundColor, backgroundImageUrl } = state["features/dynamic-branding"];
    const { isOpen: isChatOpen } = state["features/chat"];
    const { width: verticalFilmstripWidth, visible } = state["features/filmstrip"];
    const { hideDominantSpeakerBadge } = state["features/base/config"];
    const { seeWhatIsBeingShared } = state["features/large-video"];
    const localParticipantId = getLocalParticipant(state)?.id;
    const largeVideoParticipant = getLargeVideoParticipant(state);
    const videoTrack = getVideoTrackByParticipant(state, largeVideoParticipant);
    const isLocalScreenshareOnLargeVideo = largeVideoParticipant?.id?.includes(localParticipantId ?? "") && videoTrack?.videoType === VIDEO_TYPE.DESKTOP;
    return {
        _backgroundAlpha: state["features/base/config"].backgroundAlpha,
        _customBackgroundColor: backgroundColor,
        _customBackgroundImageUrl: backgroundImageUrl,
        _displayScreenSharingPlaceholder: Boolean(isLocalScreenshareOnLargeVideo && !seeWhatIsBeingShared && !isSpotTV(state)),
        _hideSelfView: getHideSelfView(state),
        _isChatOpen: isChatOpen,
        _isDisplayNameVisible: isDisplayNameVisible(state),
        _isScreenSharing: Boolean(isLocalScreenshareOnLargeVideo),
        _largeVideoParticipantId: largeVideoParticipant?.id ?? "",
        _localParticipantId: localParticipantId ?? "",
        _noAutoPlayVideo: Boolean(testingConfig?.noAutoPlayVideo),
        _resizableFilmstrip: isFilmstripResizable(state),
        _seeWhatIsBeingShared: Boolean(seeWhatIsBeingShared),
        _showDominantSpeakerBadge: !hideDominantSpeakerBadge,
        _showSubtitles: areClosedCaptionsEnabled(state) && Boolean(state["features/base/settings"].showSubtitlesOnStage),
        _verticalFilmstripWidth: verticalFilmstripWidth.current,
        _verticalViewMaxWidth: getVerticalViewMaxWidth(state),
        _visibleFilmstrip: visible,
        _whiteboardEnabled: isWhiteboardEnabled(state),
    };
}
export default connect(_mapStateToProps)(LargeVideo);
